<template>
	<v-responsive min-height="85vh" class="d-flex align-center">
		<v-container fluid fill-height justify-center tag="section">
			<v-card flat class="py-10" align="center">
				<v-row>
					<v-col cols="12" align="center">
						<v-icon size="70" color="error">fas fa-exclamation-triangle</v-icon>
					</v-col>
					<v-col cols="12" align="center">
						<div class="h3 font-weight-bold error--text" v-html="$t('global.no_permission_title')"></div>
						<div class="h6" v-html="$t('global.no_permission_message')"></div>
					</v-col>
				</v-row>
			</v-card>
		</v-container>
	</v-responsive>
</template>

<script>
export default {
	data: () => ({}),
};
</script>
